import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupportTicketsState } from './support-tickets.reducer';

export const selectSupportTicketsDataState = createFeatureSelector<SupportTicketsState>('supportTickets');

export const selectSupportTicketsList = createSelector(
  selectSupportTicketsDataState,
  (state: SupportTicketsState) => state.list
);

export const selectSupportTicketsPagination = createSelector(
  selectSupportTicketsDataState,
  (state: SupportTicketsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectSupportTicketsDataLoading = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.loading
);

export const selectSupportTicketsDataError = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.error
);

export const selectSupportTicketsDetail = createSelector(
  selectSupportTicketsDataState,
  (state: any) => state.detail
);

export const selectSupportTicketsDetailLoading = createSelector(
  selectSupportTicketsDataState,
    (state: any) => state.loading
);

export const selectSupportTicketsDetailError = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.error
);

export const selectTicketCards = createSelector(
  selectSupportTicketsDataState,
  (state: any) => state.cards
);

export const selectTicketCardsError = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.error
);

export const selectSupportTicketsReplays = createSelector(
  selectSupportTicketsDataState,
  (state: SupportTicketsState) => state.list
);

export const selectSupportTicketsReplaysLoading = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.loading
);

export const selectSupportTicketsReplaysError = createSelector(
    selectSupportTicketsDataState,
    (state: SupportTicketsState) => state.error
);
